import { timeMixin } from './time';
import { tabClickMixin } from './tab_click';
import { tabDownloadPageMixin } from './to_download';
import { appMixin } from './app';

export const mixins = {
	mixins: [ timeMixin, tabClickMixin, tabDownloadPageMixin, appMixin ]
};